import { Routes } from "@angular/router";

export const smartAccountLazyRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./smart-account-page.component").then((c) => c.SmartAccountPageComponent),
  },
];
